import fs from "fs";
import template from "bundle-text:./index.html";
import { templateLoopParser } from "../parser";

const answerTemplate = fs.readFileSync(__dirname + "/template.html", "utf8");
let page = 1;
let isLoadingMoreAnswers = false;
let loadMoreBtn;
let loadedAnswersCountCotainer;
let totalAnswersCountCotainer;
let answersCount = 0;
let answersInitialized = false;

const fetchTemplates = () => {
  isLoadingMoreAnswers = true;
  const loadingEl = document.querySelector(".answers-loading");
  if (loadingEl) loadingEl.style.display = "flex";
  const answersContainer = document.querySelector(".answers-container");

  fetch(
    `https://api.stackexchange.com/2.3/users/3025259/answers?pagesize=100&page=${page}&order=desc&sort=activity&site=stackoverflow&filter=!8qyGVhQpsLRfafW66vPQjPB0y`,
  )
    .then((response) => response.json())
    .then((response) => {
      const { items, has_more, total } = response;
      if (!has_more && loadMoreBtn) {
        loadMoreBtn.style.display = "none";
      }
      const filteredanswers = items.map((answer) => {
        const { body, share_link, title } = answer;
        return { body, share_link, title };
      });
      answersCount += items.length;
      if (loadedAnswersCountCotainer) loadedAnswersCountCotainer.innerText = answersCount;
      if (totalAnswersCountCotainer) totalAnswersCountCotainer.innerText = total;

      const answersContent = `<div class="answers-list">${templateLoopParser(filteredanswers, answerTemplate)}</div>`;
      const answers = new DOMParser().parseFromString(answersContent, "text/html");
      answers.querySelector(".answers-list").childNodes.forEach((child) => {
        answersContainer.prepend(child);
      });

      // remove loading
      if (loadingEl) loadingEl.style.display = "none";
      isLoadingMoreAnswers = false;
    })
    .catch((error) => {
      console.error("Failed to load answers:", error);
      if (loadingEl) loadingEl.style.display = "none";
      isLoadingMoreAnswers = false;
    });
};

const loadMoreSOFAnswers = () => {
  if (!isLoadingMoreAnswers) {
    page++;
    fetchTemplates();
  }
};

const initAnswers = () => {
  if (answersInitialized) return;
  answersInitialized = true;

  fetchTemplates();
  loadMoreBtn = document.querySelector("#load-more-answers");
  if (loadMoreBtn) loadMoreBtn.onclick = loadMoreSOFAnswers;
  loadedAnswersCountCotainer = document.querySelector("#loaded-answers-count");
  totalAnswersCountCotainer = document.querySelector("#total-answers-count");
};

export const Answers = () => {
  setTimeout(() => {
    // Use Intersection Observer to lazy load answers when section becomes visible
    const answersSection = document.querySelector("#answers");
    if (answersSection && "IntersectionObserver" in window) {
      const observer = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting) {
              initAnswers();
              observer.unobserve(entry.target);
            }
          });
        },
        { rootMargin: "200px" }, // Start loading 200px before section comes into view
      );
      observer.observe(answersSection);
    } else {
      // Fallback for browsers without IntersectionObserver
      initAnswers();
    }
  }, 0);

  return template;
};
